import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLike2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M19 7C19.5333 7 20 7.2 20.4 7.6C20.8 8 21 8.46666 21 9V11C21 11.1167 20.9875 11.2417 20.9625 11.375C20.9375 11.5083 20.9 11.6333 20.85 11.75L17.85 18.8C17.7 19.1333 17.45 19.4167 17.1 19.65C16.75 19.8833 16.3833 20 16 20H8C7.45 20 6.97917 19.8042 6.5875 19.4125C6.19583 19.0208 6 18.55 6 18V7.825C6 7.55833 6.05417 7.30416 6.1625 7.0625C6.27083 6.82083 6.41667 6.60833 6.6 6.42499L12.025 1.025C12.275 0.791662 12.5708 0.649995 12.9125 0.599995C13.2542 0.549995 13.5833 0.608328 13.9 0.774995C14.2167 0.941662 14.4458 1.175 14.5875 1.475C14.7292 1.775 14.7583 2.08333 14.675 2.4L13.55 7H19ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V9C0 8.45 0.195833 7.97916 0.5875 7.5875C0.979167 7.19583 1.45 7 2 7C2.55 7 3.02083 7.19583 3.4125 7.5875C3.80417 7.97916 4 8.45 4 9V18C4 18.55 3.80417 19.0208 3.4125 19.4125C3.02083 19.8042 2.55 20 2 20Z",
		fill: "#9B9B9B"
	})]
});
const ForwardRef = forwardRef(SvgLike2);
export { ForwardRef as ReactComponent };
